import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18736 16751"
    {...props}
  >
    <defs>
      <style>{".fil1{fill:#2b2a29}"}</style>
    </defs>
    <g>
      <g id="_1974323567440">
        <path
          d="M3532 9551c1629-36 2698-886 3703-1559 0 2504-325 4519 734 6284 1834 3057 6990 3640 9150-298 937-1709 642-4232 642-6766 789-210 953-586 975-1559h-2729c-1023 0-359 1307 585 1559 0 3033 500 6084-1785 7572-2581 1682-5127 369-6021-1520-1257-2659 652-8224-1163-11118C6888 975 5463 0 3532 0v9551z"
          style={{
            fill: "#000",
          }}
          className="fil1"
        />
        <path
          d="M2763 2018H25v1014h2738zM2737 6439H0v1013h2737z"
          className="fil1"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
